export default __webpack_public_path__ + "static/media/toka_girl_animation.b30cbd6c.mp4";